// extracted by mini-css-extract-plugin
export default {"wrapper":"add-sms-consent__wrapper--eTxZC"};